

$(function() {

  //シェアボタンクリック
  $('button.share').on('click', function (e) {
    e.preventDefault();
    $('#productsSharePopup').fadeIn();
  });
  //ポップアップ閉じる
  $('.products_notice_popup .close, .products_notice_popup .close_bottom').on('click', function (e) {
    e.preventDefault();
    $('.products_notice_popup').fadeOut();
  });

});

